import React from 'react';

const KeyDetails = ({ estate, t }) => {
    const details = [
        {
            key: 'type',
            label: t('estate.details.keyDetails.type'),
            value: estate.type,
            format: value => value?.charAt(0).toUpperCase() + value?.slice(1)
        },
        {
            key: 'plot_area',
            label: t('estate.details.keyDetails.plotArea'),
            value: estate.plot_area,
            format: value => `${value} m²`
        },
        {
            key: 'living_area',
            label: t('estate.details.keyDetails.livingArea'),
            value: estate.living_area,
            format: value => `${value} m²`
        },
        {
            key: 'terrace_area',
            label: t('estate.details.keyDetails.terraceArea'),
            value: estate.terrace_area,
            format: value => `${value} m²`
        },
        {
            key: 'bedrooms',
            label: t('estate.details.keyDetails.bedrooms'),
            value: estate.bedrooms
        },
        {
            key: 'bathrooms',
            label: t('estate.details.keyDetails.bathrooms'),
            value: estate.bathrooms
        },
        {
            key: 'year_built',
            label: t('estate.details.keyDetails.yearBuilt'),
            value: estate.year_built
        }
    ];

    const visibleDetails = details.filter(detail =>
        detail.value !== null &&
        detail.value !== undefined &&
        detail.value !== '' &&
        detail.value !== 0
    );

    return (
        <div className="bg-gray-50 rounded-xl p-6 text-sm md:text-base">
            <h2 className="text-lg font-semibold mb-6">{t('estate.details.keyDetails.title')}</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {visibleDetails.map(detail => (
                    <div key={detail.key} className="flex items-center space-x-3">
                        <div>
                            <p className="text-sm text-gray-500">{detail.label}</p>
                            <p className="font-medium">
                                {detail.format ? detail.format(detail.value) : detail.value}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default KeyDetails;